
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import OverlayPanel from "primevue/overlaypanel";
import {
  CLIENT_ERROR,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { Options, Vue } from "vue-class-component";
import {
  UrsaCode,
  UrsaCodeList,
  UrsaCodeListRequest
} from "@/domain/entities/OperationalArea";
import CardPopupOtherTag from "./card-popup-other-tag.vue";
import { ChipsStyles } from "@/app/ui/components/chips-v2/modules";
import {
  ErrorMessageEntities,
  TableErrorResponse,
  OptionsClass
} from "@/domain/entities/MainApp";
import { OperationalAreaController } from "@/app/ui/controllers/OperationalAreaController";

@Options({
  name: "TabHistoryHangingOutgoing",
  components: { PaginationV3, OverlayPanel, CardPopupOtherTag }
})
export default class TabsUrsa extends Vue {
  // ----------------------------------------------------------
  // State
  // ----------------------------------------------------------
  dataTable = new UrsaCodeList();

  listStatus: OptionsClass[] = [
    new OptionsClass({ name: "Aktif", value: "active" }),
    new OptionsClass({ name: "Tidak Aktif", value: "inactive" })
  ];

  // ----------------------------------------------------------
  // Lifecycle
  // ----------------------------------------------------------
  async mounted() {
    await this.getList();
  }

  // ----------------------------------------------------------
  // Computed
  // ----------------------------------------------------------
  get offset(): number {
    return (
      this.dataTable.pagination.limit * (this.dataTable.pagination.page - 1)
    );
  }

  // ----------------------------------------------------------
  // Methods
  // ----------------------------------------------------------
  onSearch(value: string) {
    if (!value.length || value.length >= 3) {
      this.dataTable.params.q = value;
      this.dataTable.pagination.page = 1;
      this.getList();
    }
  }

  onSelectStatus(item: OptionsClass) {
    this.dataTable.params.status = item;
    this.getList();
  }

  onSetPage(page: number) {
    this.dataTable.pagination.page = page;
    this.getList();
  }

  async getList() {
    try {
      const {
        params,
        pagination: { page }
      } = this.dataTable;

      this.dataTable.loading = true;
      this.dataTable.error = new TableErrorResponse();
      this.dataTable.params.page = page;

      const res = await OperationalAreaController.getUrsaCodeList(
        new UrsaCodeListRequest(params)
      );

      this.dataTable = new UrsaCodeList({
        ...res,
        params: this.dataTable.params,
        error: new TableErrorResponse({
          params: params.q || params.status.value,
          totalData: res.data.length
        })
      });
    } catch (error) {
      this.dataTable = new UrsaCodeList({
        ...this.dataTable,
        error: new TableErrorResponse({ error, onRetry: this.getList }),
        data: []
      });
    } finally {
      this.dataTable.loading = false;
    }
  }

  onClickRow(item: UrsaCode) {
    this.$router.push(`/network/operational-area/ursa?id=${item.ursaCode}`);
  }

  // ----------------------------------------------------------
  // Utils
  // ----------------------------------------------------------
  getChipsStyles(isActive: boolean) {
    return ChipsStyles({
      status: isActive ? "active" : "inactive"
    });
  }
}
